import { render, staticRenderFns } from "./DocumentoSalidasCreator.vue?vue&type=template&id=24b35bc3"
import script from "./DocumentoSalidasCreator.vue?vue&type=script&lang=js"
export * from "./DocumentoSalidasCreator.vue?vue&type=script&lang=js"
import style0 from "./DocumentoSalidasCreator.vue?vue&type=style&index=0&id=24b35bc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports